import './LoadingPulse.scss';

export default function LoadingPulse(): JSX.Element {
  return (
    <div className="loader-container">
      <div className="loader06"></div>
    </div>
  );
}
